import React from 'react'
import { Icon } from 'antd'
import { view } from 'react-easy-state'

const ContentLoader = (props) => (
  <div className="content-loader">
    <Icon type="loading" /> <h3>Please wait...</h3>
  </div>
)

export default view(ContentLoader)
